/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Click_To_Upload_Or_Drag_And_DropInputs */

const en_click_to_upload_or_drag_and_drop = /** @type {(inputs: Click_To_Upload_Or_Drag_And_DropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click to upload or drag & drop`)
};

const es_click_to_upload_or_drag_and_drop = /** @type {(inputs: Click_To_Upload_Or_Drag_And_DropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haz clic para subir o arrastra y suelta`)
};

const fr_click_to_upload_or_drag_and_drop = /** @type {(inputs: Click_To_Upload_Or_Drag_And_DropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cliquez pour uploader ou glissez-déposez`)
};

const de_click_to_upload_or_drag_and_drop = /** @type {(inputs: Click_To_Upload_Or_Drag_And_DropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum Hochladen klicken oder per Drag & Drop`)
};

const ja_click_to_upload_or_drag_and_drop = /** @type {(inputs: Click_To_Upload_Or_Drag_And_DropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クリックしてアップロード、またはドラッグ＆ドロップ`)
};

const zh_click_to_upload_or_drag_and_drop = /** @type {(inputs: Click_To_Upload_Or_Drag_And_DropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`点击上传或将文件拖放到此处`)
};

const ar_click_to_upload_or_drag_and_drop = /** @type {(inputs: Click_To_Upload_Or_Drag_And_DropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انقر للرفع أو قم بالسحب والإفلات`)
};

const id_click_to_upload_or_drag_and_drop = /** @type {(inputs: Click_To_Upload_Or_Drag_And_DropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klik untuk mengunggah atau seret & lepas`)
};

const it_click_to_upload_or_drag_and_drop = /** @type {(inputs: Click_To_Upload_Or_Drag_And_DropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clicca per caricare o trascina i file qui`)
};

const ru_click_to_upload_or_drag_and_drop = /** @type {(inputs: Click_To_Upload_Or_Drag_And_DropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нажмите для загрузки или перетащите файлы`)
};

const pt_click_to_upload_or_drag_and_drop = /** @type {(inputs: Click_To_Upload_Or_Drag_And_DropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clique para fazer upload ou arraste e solte`)
};

const ko_click_to_upload_or_drag_and_drop = /** @type {(inputs: Click_To_Upload_Or_Drag_And_DropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`클릭하여 업로드하거나 드래그 앤 드롭하세요`)
};

/**
* | output |
* | --- |
* | "Click to upload or drag & drop" |
*
* @param {Click_To_Upload_Or_Drag_And_DropInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const click_to_upload_or_drag_and_drop = /** @type {((inputs?: Click_To_Upload_Or_Drag_And_DropInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Click_To_Upload_Or_Drag_And_DropInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_click_to_upload_or_drag_and_drop(inputs)
	if (locale === "es") return es_click_to_upload_or_drag_and_drop(inputs)
	if (locale === "fr") return fr_click_to_upload_or_drag_and_drop(inputs)
	if (locale === "de") return de_click_to_upload_or_drag_and_drop(inputs)
	if (locale === "ja") return ja_click_to_upload_or_drag_and_drop(inputs)
	if (locale === "zh") return zh_click_to_upload_or_drag_and_drop(inputs)
	if (locale === "ar") return ar_click_to_upload_or_drag_and_drop(inputs)
	if (locale === "id") return id_click_to_upload_or_drag_and_drop(inputs)
	if (locale === "it") return it_click_to_upload_or_drag_and_drop(inputs)
	if (locale === "ru") return ru_click_to_upload_or_drag_and_drop(inputs)
	if (locale === "pt") return pt_click_to_upload_or_drag_and_drop(inputs)
	return ko_click_to_upload_or_drag_and_drop(inputs)
});